import script from "./AdminEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminEdit.vue?vue&type=script&setup=true&lang=js"

import "./AdminEdit.vue?vue&type=style&index=0&id=562ff8a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-562ff8a6"]])

export default __exports__